export default __webpack_public_path__ + "static/media/promo-spectrespecs_06.198c9495.jpg";